<script>
  import {calcPercent, showIntValue, showPercentValue} from "../../Common/tools";
  import Table from "../../Table/Table.svelte";
  import {External, M} from "../../external";
  import {onMount} from "svelte";
  import {EMPTY_SALES_TOTALS, getSalesCountLabel} from "../../Store/static";
  import {getCampaignSalesTotals} from "../../Campaign/static";

  export let data;

  let columns = [
    { key: "link", label: M.LINK, class: "flex-1 mw-300" },
   /* {
      key: "unique",
      label: M.UNIQUE_CLICKS,
      type: "number",
      class: "flex-none mw-100"
    },*/
    {
      key: "unique",
      label: M.CLICKED,
      type: "number",
      class: "flex-none mw-100"
    }
  ];

  const openRate = showPercentValue(data, "openRate");
  const clickRate = showPercentValue(data, "clickRate");

  let salesTotals = EMPTY_SALES_TOTALS;

  onMount(async () => {
    if (data.data.salesUtm) {
      salesTotals = await getCampaignSalesTotals(data);
    }
  });

</script>

<div class="flex col20 f-left store-section-analytics-warapper three-columns flex-col-mobile mt-15" style="background: rgb(245, 246, 250);">
  <div class="analytics-box">
    <h3>{M.AUDIENCE}</h3>
    <h2 class="col20 f-left f-28 gray-text"><b>{showIntValue(data, "send")}</b></h2>
  </div>
  <div class="analytics-box">
    <h3>{M.OPENED_EMAILS}</h3>
    <h2 class="col20 f-left f-28 gray-text">
      <b>
        {openRate}
        <span class="increase">({showIntValue(data, "open")})</span>
      </b>
    </h2>
  </div>
  <div class="analytics-box">
    <h3>{M.CLICKED_IN_EMAIL}</h3>
    <h2 class="col20 f-left f-28 gray-text">
      <b>
        {clickRate}
        <span class="increase">
          ({showIntValue(data, "click")})
        </span>
      </b>
    </h2>
  </div>
  {#if data.data.salesUtm}
    <div class="analytics-box">
      <h3>{M.PURCHASED}</h3>
      <h2 class="col20 f-left f-28 gray-text">
        <b>
          {External.Tools.currencyToStrWithSymbol(salesTotals.sales)}
          <span class="increase">
            ({salesTotals.orders})
          </span>
        </b>
      </h2>
    </div>
  {/if}
</div>
<div class="flex f-left col20 mt-25">
  <div class="analytics-box-half" style="padding-right: 0;">
    <h2 class="col20 f-left f-28 gray-text">{M.EMAIL_FLOW}</h2>
    <div class="chart-wrapper col20 f-left mt-35">
      <div class="horizontal-chart-wrapper flex align-center">
        <h4>{M.SENT}</h4>
        <div class="horizontal-chart-progress">
          <div class="horizontal-chart-progress-inner" style="width:100%;"><span class="chart-label">100%</span></div>
        </div>
      </div>
      <div class="horizontal-chart-wrapper flex align-center">
        <h4>{M.OPENED}</h4>
        <div class="horizontal-chart-progress">
          <div class="horizontal-chart-progress-inner" style="width:{openRate}; background-color: #cac736">
            <span class="chart-label">{openRate}</span>
          </div>
        </div>
      </div>
      <div class="horizontal-chart-wrapper flex align-center">
        <h4>{M.CLICKED}</h4>
        <div class="horizontal-chart-progress">
          <div class="horizontal-chart-progress-inner" style="width:{clickRate}; background-color: #76bd65">
            <span class="chart-label">{clickRate}</span>
          </div>
        </div>
      </div>
      {#if data.data.salesUtm}
        <div class="horizontal-chart-wrapper flex align-center">
          <h4>{M.PURCHASED}</h4>
          <div class="horizontal-chart-progress">
            <div class="horizontal-chart-progress-inner" style={"width:" + calcPercent(salesTotals.orders, data.data.audience) + "; background-color: #76bd65"}>
              <span class="chart-label">{calcPercent(salesTotals.orders, data.data.audience)} - {External.Tools.currencyToStrWithSymbol(salesTotals.sales)} ({getSalesCountLabel(salesTotals.orders)})</span>
            </div>
          </div>
        </div>
      {/if}
    </div>
  </div>
  <div class="analytics-box-half automation-goal-wrapper mb-35 campaign-links-table">
    <h2 class="col20 f-left f-21 mb-15 gray-text">{M.EMAIL_LINKS}</h2>
    {#if data.linkStats}
      <Table data={data.linkStats} hasSelection={false} activeColumns={columns} />
    {:else}
      <div class="no-data-box text-center">
        <h4>{M.NO_CLICKS_YET}</h4>
      </div>
    {/if}
  </div>
</div>

<div class="flex col20 f-left store-section-analytics-warapper three-columns flex-col-mobile mt-15 mb-35" style="background: rgb(245, 246, 250);">
  <div class="analytics-box">
    <h3>{M.UNSUBSCRIBED}</h3>
    <h2 class="col20 f-left f-28 gray-text">
      <b>
        {showPercentValue(data, "unsubscribeRate")}
        <span class="decrease">{showIntValue(data, "unsubscribed")}</span>
      </b>
    </h2>
  </div>
  <div class="analytics-box">
    <h3>{M.BOUNCED}</h3>
    <h2 class="col20 f-left f-28 gray-text">
      <b>{showPercentValue(data, "bounceRate")} <span class="decrease">{showIntValue(data, "bounced")}</span></b>
    </h2>
  </div>
  <div class="analytics-box">
    <h3>{M.MARKED_AS_SPAM}</h3>
    <h2 class="col20 f-left f-28 gray-text">
      <b>{showPercentValue(data, "complaintRate")} <span class="decrease">{showIntValue(data, "complaint")}</span></b>
    </h2>
  </div>
</div>
